import React, { useState, useEffect, memo, useMemo } from 'react';
import Header from '../../layout/Header';
import { connect } from 'react-redux';
import { STATIC_COLUMNS } from './column';
import Paginated from './Paginated';
import { getDate, getDisplayDate, selectValueGetter } from '../../../utils/helper';
import { Link } from 'react-router-dom';
import { importIcon } from '../../../Image/Index';
import TransactionViewModal from './TransactionViewModal';
import { getTransaction, clearTransaction } from '../../../actions/transaction';
import { getVoucherTemplate, schema } from '../../../services/services';
import { ValidatorForm } from 'react-form-validator-core';
import SelectValidator from '../../partial/SelectValidator';
import { getAllTrasaction } from '../../../services/auth';
import { decrypt } from '../../../utils/encodingdecoding';

const TransactionsList = memo(
	({ getTransaction, Transaction, clearTransaction }) => {
		const [data, setData] = useState([]);
		const [transactionCount, setTransactionCount] = useState();
		const [valueselect, setValueSelect] = useState('all');
		const [loader, setLoader] = useState(true);
		const [showLogin, setShowLogin] = useState(false);
		const [transactionId, setTransactionId] = useState('');
		const [voucher, setVoucher] = useState([]);
		const [schemaData, setSchemaData] = useState([]);
		const [option] = useState([
			{ label: 'All', value: 'all' },
			{ label: 'Qualified', value: 'qualified' },
			{ label: 'Not Qualified', value: 'notQualified' },
		]);
		let id = decrypt(localStorage.getItem('Id'));
		const [filterOption, setFilterOption] = useState('all');

		const unPeople = (e) => {
			setValueSelect(e.value);
			setFilterOption(e.value);
		};

		const onSubmit = () => { };
		useEffect(() => {
			let tempPageIndex = JSON.parse(
				localStorage.getItem('TransPageIndex'),
			);
			if (tempPageIndex === 1) {
				fetch();
			}
			// eslint-disable-next-line
		}, []);

		const getTransSchema = () => {
			// setLoader(true)
			const token = JSON.parse(localStorage.getItem('token_gen'));
			let schemaName = localStorage.getItem('schemaName');
			schemaName = schemaName?.split(' ')?.join('');
			schema(token?.access_token, schemaName)
				.then((res) => {
					setSchemaData(res?.data?.schema?.properties);
					// setLoader(false)
				})
				.catch(() => {
					// setLoader(false)
				});
		};

		useEffect(() => {
			getTransSchema();
		}, []);

		useEffect(() => {
			const ShortData = async () => {
				const tempData = Transaction?.data?.transactions;
				(await tempData) &&
					tempData?.map((val) => {
						val.isQualified =
							val?.transactionDetail?.transactionType ===
								'purchase'
								? val?.qualifiedCampaign?.length
									? 'Yes'
									: 'No'
								: '-';
						val.totalAmount = val?.transactionDetail?.totalAmount
							? val?.transactionDetail?.totalAmount
							: '-';
						val.rewardId = val?.qualifiedCampaign?.length
							? val?.transactionDetail?.reward_id
							: '-';
						val.transactionType =
							val?.transactionDetail?.transactionType ===
								'transfer'
								? 'reversal'
								: val?.transactionDetail?.bitType?.length > 0
									? val?.transactionDetail?.bitType
									: val?.transactionDetail?.transactionType;
						var total = 0;
						val?.qualifiedCampaign?.map((value) => {
							if (value.type === 'voucher') {
								total = value.value;
							}
						});

						voucher?.voucherTemplate?.length &&
							voucher?.voucherTemplate?.map((data) => {
								if (total == data.code)
									total = data.voucherValue;
							});

						// Group by type and sum values
						const grouped = Array.isArray(val?.qualifiedCampaign)
							? val.qualifiedCampaign.reduce((acc, item) => {
								if (item?.value > 0) {
									const type = item?.type?.toLowerCase();
									acc[type] =
										(acc[type] || 0) + item.value;
								}
								return acc;
							}, {})
							: {};

						val.earning =
							val?.qualifiedCampaign?.[0]?.walletFor ===
								'Merchant'
								? `${val?.qualifiedCampaign?.[0]?.value} point`
								: val.transactionDetail?.transactionType ===
									'redeem'
									? `${val.transactionDetail?.values} point`
									: (val.earning =
										val.transactionDetail
											?.transactionType === 'refund'
											? `${val.transactionDetail?.transactionAmount} point`
											: Object?.entries(grouped)
												?.map(([type, total]) =>
													type === 'voucher'
														? `Earn voucher worth ${total}`
														: decrypt(
															localStorage.getItem(
																'Id',
															),
														)`${total} point`,
												)
												.join(', '));

						if (schemaData) {
							Object.keys(schemaData).forEach((key) => {
								if (schemaData[key]?.isFormView) {
									val[key] =
										val?.transactionDetail?.[key] || '';
								}
							});
						}

						return (
							(val.customercode = Array.isArray(val?.customer)
								? val.customer?.[0]?.customercode
								: val.customer?.customercode),
							val.transactionId,
							((val.transactionProcessedDate = getDisplayDate(
								val?.transactionProcessedDate
							)),
								(val.qrcode = 'true'),
								(val.action = (
									<Link
										to=''
										state={{
											transactionId: Array.isArray(
												val.customer,
											)
												? val?.customer?.[0]?.customercode
												: val?.customer?.customercode,
										}}
										onClick={() =>
											handleViewModal(val.transactionId)
										}>
										<i className='fa-solid fa-eye'></i> View
										Details
									</Link>
								)))
						);
					});

				if (tempData) {
					await tempData.sort(function (a, b) {
						if (a.transactionProcessedDate === null) {
							return 1;
						} else if (b.transactionProcessedDate === null) {
							return -1;
						}
						const dateA = new Date(a.transactionProcessedDate);
						const dateB = new Date(b.transactionProcessedDate);
						if (dateA < dateB) {
							return 1;
						} else if (dateA > dateB) {
							return -1;
						} else {
							const timeA = dateA.getTime();
							const timeB = dateB.getTime();
							return timeB - timeA;
						}
					});
				}
				tempData?.map((val) => {
					const filteredData =
						filterOption === 'all'
							? tempData
							: tempData.filter((val) => {
								if (filterOption === 'qualified') {
									return (
										val?.transactionDetail
											?.transactionType ===
										'purchase' &&
										val?.qualifiedCampaign?.length
									);
								} else if (
									filterOption === 'notQualified'
								) {
									return (
										val?.transactionDetail
											?.transactionType ===
										'purchase' &&
										val?.qualifiedCampaign?.length == 0
									);
								}
								return false;
							});
					setData(filteredData);
				});
			};

			ShortData();
		}, [Transaction, voucher, filterOption]);

		const dynamicColumns = useMemo(() => {
			if (!schemaData) return [];

			return Object.entries(schemaData)
				.filter(
					([key, value]) =>
						value.isFormView &&
						key !== 'mobile'
				)
				.map(([key, value]) => ({
					Header: value.fielddisplayname || value.label || key,
					Footer: value.fielddisplayname || value.label || key,
					accessor: key,
				}));
		}, [schemaData]);

		const columns = useMemo(() => {
			const staticColumns = [
				...dynamicColumns,
				...STATIC_COLUMNS,
			];
			return staticColumns;
		}, [dynamicColumns]);

		const fetch = async () => {
			setLoader(true);
			await clearTransaction();
			const token = JSON.parse(localStorage.getItem('token_gen'));
			let id = localStorage.getItem('Id');
			await getTransaction(token?.access_token, id, 1, 50);
			await getVoucherTemplate(token?.access_token).then((res) => {
				setVoucher({ ...voucher, voucherTemplate: res.data });
			});
			setLoader(false);
		};

		const handleViewModal = (data) => {
			setShowLogin(true);
			setTransactionId(data);
		};

		const generateCSV = async () => {
			setLoader(true);

			try {
				const token = JSON.parse(localStorage.getItem('token_gen'));
				const id = localStorage.getItem('Id');

				if (!token?.access_token || !id) {
					throw new Error('Missing token or ID');
				}
				const response = await getAllTrasaction(
					token.access_token,
					id,
					1,
					transactionCount,
				);
				const transactions = response?.transactions || [];
				const transformedData = transactions?.map((val) => {
					let earning = val?.earning || 0;
					let total = 0;
					let type = '';

					const positiveValues =
						val?.qualifiedCampaign?.filter(
							(item) => item.value > 0,
						) || [];
					const totalPositiveValue = positiveValues?.reduce(
						(acc, curr) => acc + curr.value,
						0,
					);

					val?.qualifiedCampaign?.forEach((value) => {
						if (value.type === 'voucher') {
							total = value.voucherTemplateCode || 0;
							type = value.type;
						}
					});

					if (type === 'voucher') {
						const voucher = response.voucher?.voucherTemplate?.find(
							(data) => data.code === total,
						);
						total = voucher?.voucherValue || 0;
						earning = `Earn voucher worth ${total}`;
					} else if (totalPositiveValue) {
						earning = `${totalPositiveValue}`;
					} else {
						earning = 0;
					}

					return {
						transactionId: val?.transactionId || 'N/A',
						isQualified:
							val?.transactionDetail?.transactionType ===
								'purchase' && val?.qualifiedCampaign?.length
								? 'Yes'
								: 'No',
						totalAmount: val?.transactionDetail?.totalAmount
							? val?.transactionDetail?.totalAmount
							: '-',
						transactionType: val?.transactionDetail?.bitType?.length
							? val?.transactionDetail?.bitType
							: val?.transactionDetail?.transactionType || 'N/A',
						earning,
						transactionProcessedDate:
							getDisplayDate(
								val?.transactionProcessedDate
							) || 'N/A',
					};
				});
				const csvHeaders = [
					'Transaction ID',
					'IsQualified',
					'Transaction Type',
					'Earning',
					'Date'
				];
				const csvData = [
					csvHeaders,
					...transformedData?.map((row) => [
						row.transactionId,
						row.isQualified,
						row.transactionType,
						row.earning,
						row.transactionProcessedDate
					]),
				];
				const csvContent =
					'data:text/csv;charset=utf-8,' +
					csvData.map((row) => row.join(',')).join('\n');
				const encodedUri = encodeURI(csvContent);
				const link = document.createElement('a');
				link.setAttribute('href', encodedUri);
				link.setAttribute('download', 'report.csv');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (error) {
				console.error('Error generating CSV:', error.message || error);
			} finally {
				setLoader(false);
			}
		};

		useEffect(() => {
			setTransactionCount(Transaction?.data?.totalCount);
		}, [Transaction]);

		return (
			<>
				<Header
					name={'Transaction'}
				/>
				{loader && (
					<div className='mainPreloaderMain'>
						<div className='mainPreloader'>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
					</div>
				)}
				<div className='dashboard__content'>
					<div className='container-fluid'>
						<div className='dashboard__transactionsCard'>
							<div className='dashboard__header'>
								<div className='dashboard__left'>
									<h4>Transaction Data</h4>
								</div>
								<div className='dashboard__right'>
									<Link
										to='/uploading-existing-datas?type=transaction'
										id='upload_transction'
										state={{
											prevPath: '/transactions-list',
											from: 'transaction',
										}}
										className='btn btn-default'>
										<img
											src={importIcon}
											alt=''
										/>{' '}
										Upload Transaction
									</Link>
								</div>
							</div>
							<div className='dashboard__body'>
								<p>No existing transaction data.</p>
								<p>
									You can add data by uploading a CSV file
									containing the details.{' '}
								</p>
							</div>
						</div>
						{showLogin && (
							<TransactionViewModal
								show={showLogin}
								close={() => setShowLogin(false)}
								transactionId={transactionId}
							/>
						)}

						<div className='dashboard__transactionsCard'>
							<div className='dashboard__header'>
								<div className='dashboard__left'>
									<h4 id='transction_list'>
										All Transactions
									</h4>
								</div>
								<div className='dashboard__right'>
									<button
										onClick={generateCSV}
										className='btn btn-default'>
										<i
											class='fa-solid fa-download'
											style={{ marginRight: '10px' }}></i>
										Download Transaction
									</button>
								</div>
							</div>
							<div className='dashboard__body'>
								{/* <div className="dashboard__heading mb-0">
                                <div className="dashboard__headingLeft">
                                    <div className="form-group allDropdown">
                                        <ValidatorForm onSubmit={onSubmit}>
                                            <SelectValidator placeholder="Select" className="" name="choice" value={selectValueGetter(option, valueselect)} options={option} onChange={unPeople} />
                                        </ValidatorForm>
                                    </div>
                                </div>

                                <div className="dashboard__headingRight">
                                    <div
                                        className="dropdown"
                                        style={{
                                            justifyContent: "end",
                                            display: "flex",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        <button
                                            className="btn btn-danger"
                                            type="button"
                                            onClick={generateCSV}
                                        >
                                            Download CSV
                                        </button>
                                    </div>
                                </div>


                            </div> */}
								<Paginated
									data={data}
									columns={columns}
									setLoader={setLoader}
									loader={loader}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	},
);

const mapStateToProps = (state) => ({
	Transaction: state.Transaction,
});
const mapDispatchToProps = {
	getTransaction,
	clearTransaction,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsList);
